import { roomPid } from "../room";
import { timestamp } from "../timestamp";
import { rtmpDestinationEntityId } from "./rtmp-destination-entity-id";
import { rtmpDestinationKey } from "./rtmp-destination-key";
import { rtmpDestinationUrl } from "./rtmp-destination-url";

export const rtmpDestinationV2EntityRaw = {
  type: "object",
  required: ["id", "url", "key", "updatedAt"],
  properties: {
    id: rtmpDestinationEntityId,
    url: rtmpDestinationUrl,
    key: rtmpDestinationKey,
    roomId: roomPid,
    updatedAt: timestamp
  }
};
